/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../../../theme/css/select.css.ngstyle';
import * as i1 from '../../../node_modules/select2/dist/css/select2.css.ngstyle';
import * as i2 from '../../../node_modules/@swimlane/ngx-datatable/release/index.css.ngstyle';
import * as i3 from '../../../node_modules/@swimlane/ngx-datatable/release/assets/icons.css.ngstyle';
import * as i4 from '../../../node_modules/@swimlane/ngx-datatable/release/themes/material.css.ngstyle';
import * as i5 from '../../../node_modules/@qontu/ngx-inline-editor/themes/bootstrap.css.ngstyle';
import * as i6 from '../../../theme/css/datatable.css.ngstyle';
import * as i7 from '@angular/core';
import * as i8 from '../Managment/customerManagement/modal/customerModal.component.ngfactory';
import * as i9 from '../../../../app/components/Managment/customerManagement/modal/customerModal.component';
import * as i10 from '../../../../app/services/customerService';
import * as i11 from '@angular/router';
import * as i12 from 'ng2-toastr/src/toast-manager';
import * as i13 from '../../../../app/services/extraDataService';
import * as i14 from '../../../../app/services/userViewService';
import * as i15 from '../../../../app/services/emailService';
import * as i16 from '../../../../app/common/managers/storageManager';
import * as i17 from '../../../../app/services/paymentService';
import * as i18 from '../../../../app/services/configService';
import * as i19 from '../sidebar/sideBar/sideBar.component.ngfactory';
import * as i20 from '../../../../app/components/sidebar/sideBar/sideBar.component';
import * as i21 from '../navbar/navbar.component.ngfactory';
import * as i22 from '../../../../app/components/navbar/navbar.component';
import * as i23 from '@angular/common';
import * as i24 from '../../../../app/components/layout/layout.component';
const styles_LayoutComponent:any[] = [i0.styles,i1.styles,i2.styles,i3.styles,i4.styles,
    i5.styles,i6.styles];
export const RenderType_LayoutComponent:i7.RendererType2 = i7.ɵcrt({encapsulation:2,
    styles:styles_LayoutComponent,data:{}});
function View_LayoutComponent_1(_l:any):i7.ɵViewDefinition {
  return i7.ɵvid(0,[(_l()(),i7.ɵeld(0,(null as any),(null as any),6,'div',[['class',
      'spinner-circle']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i7.ɵted((null as any),[' '])),(_l()(),i7.ɵeld(0,(null as any),(null as any),
          3,':svg:svg',[['class','spinner-circular'],['viewBox','25 25 50 50']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i7.ɵted((null as any),
          [' '])),(_l()(),i7.ɵeld(0,(null as any),(null as any),0,':svg:circle',[['class',
          'path'],['cx','50'],['cy','50'],['fill','none'],['r','20'],['stroke-miterlimit',
          '10'],['stroke-width','2']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i7.ɵted((null as any),[' '])),(_l()(),i7.ɵted((null as any),
          [' ']))],(null as any),(null as any));
}
export function View_LayoutComponent_0(_l:any):i7.ɵViewDefinition {
  return i7.ɵvid(0,[i7.ɵqud(402653184,1,{navBar:0}),i7.ɵqud(402653184,2,{mainPanel:0}),
      i7.ɵqud(402653184,3,{customerModal:0}),(_l()(),i7.ɵeld(0,(null as any),(null as any),
          1,'customer-modal',([] as any[]),(null as any),[[(null as any),'scroll'],
              [(null as any),'mousewheel'],['document','keydown']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('scroll' === en)) {
              const pd_0:any = ((<any>i7.ɵnov(_v,4).onMousewheel($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('mousewheel' === en)) {
              const pd_1:any = ((<any>i7.ɵnov(_v,4).onMousewheel($event)) !== false);
              ad = (pd_1 && ad);
            }
            if (('document:keydown' === en)) {
              const pd_2:any = ((<any>i7.ɵnov(_v,4).onArrowDown($event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i8.View_CustomerModalComponent_0,i8.RenderType_CustomerModalComponent)),
      i7.ɵdid(114688,[[3,4],['customerModal',4]],0,i9.CustomerModalComponent,[i10.CustomerService,
          i11.Router,i12.ToastsManager,i7.ChangeDetectorRef,i13.ExtraDataService,i14.UserViewService,
          i15.EmailService,i16.StorageManager,i17.PaymentService,i18.ConfigService],
          (null as any),(null as any)),(_l()(),i7.ɵted((null as any),[' '])),(_l()(),
          i7.ɵeld(0,(null as any),(null as any),16,'div',[['class','wrapper']],(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i7.ɵted((null as any),
          [' '])),(_l()(),i7.ɵeld(0,(null as any),(null as any),1,'side-bar',([] as any[]),
          (null as any),(null as any),(null as any),i19.View_SideBarComponent_0,i19.RenderType_SideBarComponent)),
      i7.ɵdid(4308992,(null as any),0,i20.SideBarComponent,[i11.Router,i16.StorageManager],
          {isMobileMenu:[0,'isMobileMenu'],menuItems:[1,'menuItems']},(null as any)),
      (_l()(),i7.ɵted((null as any),[' '])),(_l()(),i7.ɵeld(0,[[2,0],['mainPanel',
          1]],(null as any),10,'div',[['class','main-panel'],['id','mainPanel']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i7.ɵted((null as any),
          [' '])),(_l()(),i7.ɵeld(0,(null as any),(null as any),1,'navbar',([] as any[]),
          (null as any),(null as any),(null as any),i21.View_NavbarComponent_0,i21.RenderType_NavbarComponent)),
      i7.ɵdid(114688,[[1,4],['navBar',4]],0,i22.NavbarComponent,[i7.ElementRef,i11.Router,
          i16.StorageManager,i23.Location],{isMobileMenu:[0,'isMobileMenu']},(null as any)),
      (_l()(),i7.ɵted((null as any),[' '])),(_l()(),i7.ɵeld(16777216,(null as any),
          (null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),i7.ɵdid(212992,(null as any),
          0,i11.RouterOutlet,[i11.ChildrenOutletContexts,i7.ViewContainerRef,i7.ComponentFactoryResolver,
              [8,(null as any)],i7.ChangeDetectorRef],(null as any),(null as any)),
      (_l()(),i7.ɵted((null as any),[' '])),(_l()(),i7.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_LayoutComponent_1)),i7.ɵdid(16384,(null as any),
          0,i23.NgIf,[i7.ViewContainerRef,i7.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i7.ɵted((null as any),[' '])),(_l()(),i7.ɵted((null as any),[' ']))],
      (_ck,_v) => {
        var _co:i24.LayoutComponent = _v.component;
        _ck(_v,4,0);
        const currVal_0:any = _co.isMobileMenu;
        const currVal_1:any = _co.menuItems;
        _ck(_v,9,0,currVal_0,currVal_1);
        const currVal_2:any = _co.isMobileMenu;
        _ck(_v,14,0,currVal_2);
        _ck(_v,17,0);
        const currVal_3:any = _co.loading;
        _ck(_v,20,0,currVal_3);
      },(null as any));
}
export function View_LayoutComponent_Host_0(_l:any):i7.ɵViewDefinition {
  return i7.ɵvid(0,[(_l()(),i7.ɵeld(0,(null as any),(null as any),1,'layout',([] as any[]),
      (null as any),[['window','resize'],['window','popstate']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('window:resize' === en)) {
          const pd_0:any = ((<any>i7.ɵnov(_v,1).onResize()) !== false);
          ad = (pd_0 && ad);
        }
        if (('window:popstate' === en)) {
          const pd_1:any = ((<any>i7.ɵnov(_v,1).hideSelect2($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },View_LayoutComponent_0,RenderType_LayoutComponent)),i7.ɵdid(4440064,(null as any),
      0,i24.LayoutComponent,[i11.Router,i7.Renderer2,i16.StorageManager],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const LayoutComponentNgFactory:i7.ComponentFactory<i24.LayoutComponent> = i7.ɵccf('layout',
    i24.LayoutComponent,View_LayoutComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./compiled/app/components/layout/layout.component.ngfactory.ts